
<div *ngIf="hasPrototypeDetailsError && !isLoading">
	<div class="card-title-block-non-sticky">
		<copo-back-button></copo-back-button>
		<span class="card-title-label" translate>prototype-card</span>
	</div>
	<div class="error-alert-box">
	<div class="card-block copo-notification-block">
		<mat-icon svgIcon="alert" [attr.title]="'quapp.alert' | translate" class="copo-notification-icon copo-hint-warning"></mat-icon>
		<div class="error-message">
			<div class="error-alert-title" translate>fastlane.prototype.not.found</div>
			<div class="error-alert-title" translate>prototype-card.data-not-found</div>
		</div>
	</div>
	</div>
</div>
<div class="sidenav-content" *ngIf="!(hasPrototypeDetailsError && !isLoading)">
	<ng-container *ngIf="!isOffline; else offline">
		<ng-container *ngIf="!isLoading else loading">
			<ng-container *ngIf="order && !hasPrototypeDetailsError">
				<div class="card-title-block-non-sticky">
					<copo-back-button></copo-back-button>
					<span class="card-title-label" translate>prototype-card</span>
					<span class="card-title-label">{{ order.customerRequestName }}/{{ order.prototypeName }}</span>
					<span class="card-title-label">{{ order.supplierRfqNumber }}</span>
					<button type="button" mat-icon-button (click)="print()" class="print-button">
						<mat-icon svgIcon="md:print" class="print-icon"></mat-icon>
					</button>
				</div>
				<div class="grid-7 copo-container">
					<div class="grid-column-request-card">
						<mat-expansion-panel [expanded]="true" class="card-info-block">
							<mat-expansion-panel-header>
								<mat-panel-title class="card-content-title">
									<span translate>request.card.information</span>
								</mat-panel-title>
							</mat-expansion-panel-header>
							<mat-divider class="margin-expansion-panel"></mat-divider>
							<div class="card-content-block col-2">
								<div class="card-contents-infos">
									<div class="card-content-info">
										<div class="card-content-label" translate>datacenter-filter.customer-req-name
										</div>
										<div class="card-content-value">
											{{replaceNullOrUndefinedWithDashes(order.customerRequestName)}}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>datacenter-shipment.customer</div>
										<div class="card-content-value">
											{{replaceNullOrUndefinedWithDashes(soldToCodeValue)}}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>datacenter-filter.req-desc</div>
										<div class="card-content-value">{{
											replaceNullOrUndefinedWithDashes(order.description) }}
										</div>
									</div>
								</div>
								<div class="card-contents-infos">
									<div class="card-content-info">
										<div class="card-content-label" translate>
											application.procurement.supplier.rfqNumber</div>
										<div class="card-content-value">{{
											replaceNullOrUndefinedWithDashes(order.supplierRfqNumber) }}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>fastlane.wizard.currency</div>
										<div class="card-content-value">
											{{replaceNullOrUndefinedWithDashes(getCurrencyValues())}} </div>
									</div>
								</div>
							</div>
						</mat-expansion-panel>
					</div>
					<div class="grid-column-prototype-status">
						<mat-expansion-panel [expanded]="true" class="card-info-block">
							<mat-expansion-panel-header>
								<mat-panel-title class="card-content-title">
									<span translate class="in-productopn-label">prototype.tracker.status</span>
									<span class="in-productopn-label">
									</span>
								</mat-panel-title>
							</mat-expansion-panel-header>
							<div class="expansion-panel-body">
							<mat-divider class="margin-expansion-panel"></mat-divider>
							<div [ngClass]="{'copo-card-grid-container': true, 'card-grid-padding': !order.materialNotAvailable, 'copo-status-tracker-container': order.materialNotAvailable, 'card-grid-material-unavailable': order.materialNotAvailable}">
								<copo-status-tracker [statuses]="getStatusList()" [currentIndex]="getCurrentIndex()">
								</copo-status-tracker>
							</div>
							</div> 
						</mat-expansion-panel>
					</div>
				</div>
				<div class="grid-6 copo-prototype-card copo-container">
					<div class="grid-column-one-full">
						<mat-expansion-panel [expanded]="true" class="card-info-block">
							<mat-expansion-panel-header>
								<mat-panel-title class="card-content-title">
									<span translate>card.prototype</span>
								</mat-panel-title>
							</mat-expansion-panel-header>
							<mat-divider class="margin-expansion-panel"></mat-divider>
							<div class="card-content-block">
								<div class="card-contents-infos">
									<div class="card-content-info">
										<div class="card-content-label" translate>datacenter-filter.proto-name</div>
										<div class="card-content-value">
											{{replaceNullOrUndefinedWithDashes(order.prototypeName)}}</div>
									</div>
								</div>
								<div class="card-contents-infos">
									<div class="card-content-info">
										<div class="card-content-label" translate>datacenter-filter.user-creation-date
										</div>
										<div class="card-content-value">
											{{replaceNullOrUndefinedWithDashes(order.creationDate|copoDate:'date')}}
										</div>
									</div>
								</div>
								<div class="card-contents-infos">
									<div class="card-content-info">
										<div class="card-content-label" translate>card.prototype.lastModificationdate
										</div>
										<div class="card-content-value">
											{{replaceNullOrUndefinedWithDashes(order.lastModifiedDate
											|copoDate:'date')}}
										</div>
									</div>
								</div>
							</div>
						</mat-expansion-panel>
					</div>
				</div>
				<!-- PRODUCTION -->
				<div *ngIf="isInProduction()" class="card-title-block-non-sticky">
					<div class="copo-proposal-product">
						<div class="card-title-label card-title-proposal" translate>card.prototype.production</div>
						<div class="copo-price" *ngIf="order.poNumber">
							<span class="copo-proposed-price" translate>
								prototype.production-po-reception-date</span><span>:</span>
							<span
								class="copo-total-price">{{replaceNullOrUndefinedWithDashes(order.poConfirmationReceivedDate|copoDate:'date')}}
								&nbsp;
								({{replaceNullOrUndefinedWithDashes(order.poReceivedWeek)}})</span>
						</div>
					</div>
				</div>
				<div *ngIf="isInProduction()" class="grid-6 copo-container">
					<div class="grid-column-one-third">
						<mat-expansion-panel [expanded]="true" class="card-info-block">
							<mat-expansion-panel-header>
								<mat-panel-title class="card-content-title">
									<span translate class="in-productopn-label">prototype.production.po.order</span>
								</mat-panel-title>
							</mat-expansion-panel-header>
							<mat-divider class="margin-expansion-panel"></mat-divider>
							<div class="card-content-block">
								<div class="card-contents-infos">
									<div class="card-content-info">
										<div class="card-content-label" translate>
											datacenter-filter.customer-order-number</div>
										<div class="card-content-value">
											{{replaceNullOrUndefinedWithDashes(order.poNumber)}}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>order.supplier.order.number</div>
										<div class="card-content-value">{{replaceNullOrUndefinedWithDashes(
											order.processingOrderNumber)}}</div>
									</div>
								</div>
							</div>
						</mat-expansion-panel>
					</div>
					<div class="grid-column-two-third">
						<mat-expansion-panel [expanded]="true" class="card-info-block">
							<mat-expansion-panel-header>
								<mat-panel-title class="card-content-title">
									<span translate>prototype.production.po-delivery</span>
								</mat-panel-title>
							</mat-expansion-panel-header>
							<mat-divider class="margin-expansion-panel"></mat-divider>
							<div class="card-content-block">
								<div class="card-contents-infos">
									<div class="card-content-info">
										<div class="card-content-label" translate>
											datacenter-filter.delivery-address-order</div>
										<div class="card-content-value">
											{{replaceNullOrUndefinedWithDashes(order.shipToDescription)}}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>datacenter-filter.delay</div>
										<div class="card-content-value">
											{{replaceNullOrUndefinedWithDashes(order.delay)}}</div>
									</div>
								</div>
								<div class="card-contents-infos">
									<div class="card-content-info">
										<div class="card-content-label" translate>datacenter-filter.shipping-week</div>
										<div class="card-content-value">
											{{replaceNullOrUndefinedWithDashes(order.shippingWeek)}}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>datacenter-filter.shipping-date</div>
										<div class="card-content-value">{{replaceNullOrUndefinedWithDashes(
											order.shippingDate|copoDate:'date')}}</div>
									</div>
								</div>
								<div class="card-contents-infos">
									<div class="card-content-info">
										<div class="card-content-label" translate>datacenter-filter.transport-reference
										</div>
										<div class="card-content-value">
											{{replaceNullOrUndefinedWithDashes(order.transportRef)}}
										</div>
									</div>
								</div>
							</div>
						</mat-expansion-panel>
					</div>
				</div>
				<!-- PROPOSAL -->
				<div *ngIf="isInProposal()" class="card-title-block-non-sticky">
					<div class="copo-proposal-product">
						<div class=" card-title-label card-title-proposal" translate>prototype.card.proposal
							<button type="button" *ngIf="order.prototypeStatus!=='closed' && order.prototypeStatus!=='proposal'" class="status-button"
								[ngClass]="{'status-accepted':order.prototypeStatus==='accepted',
															'status-refused':order.prototypeStatus==='refused',
															'status-not-avalable':order.materialNotAvailable===true}"
								mat-raised-button>{{getCurrentStatuslabel()}}</button>
							<span class="copo-error-msg">{{proposalstatusmessage}}</span>
						</div>
						<div class="copo-price">
							<span class="copo-proposed-price" translate>
								prototype-card-details.proposed-price</span><span>:</span>
							<span class="copo-total-price"
								*ngIf="!order?.materialNotAvailable else materialNotAvailable">{{order.price}}€
								&nbsp;({{order.pricePerUnit}}€/t)</span>
							<ng-template #materialNotAvailable><span
									translate>&nbsp;prototype-card-details.proposed-price.na</span></ng-template>
						</div>
					</div>
				</div>
				<div *ngIf="isInProposal()&& !order.materialNotAvailable" class="grid-6 copo-container">
					<div class="grid-column-two-third">
						<mat-expansion-panel [expanded]="true" class="card-info-block">
							<mat-expansion-panel-header>
								<mat-panel-title class="card-content-title card-header-title">
									<span translate>prototype.card.proposal.product.information</span>
									<span translate
										class="card-content-stock">prototype.card.product.source<span>:&nbsp;</span>
										<span *ngIf="order?.materialNotAvailable else materialavailable"
											translate>fastlane.itemlist.product.coil_axis.default</span>
										<ng-template #materialavailable>
											<span> {{order.materialAvailability}}</span>
										</ng-template>
									</span>
								</mat-panel-title>
							</mat-expansion-panel-header>
							<mat-divider class="margin-expansion-panel"></mat-divider>
							<div>
								<div *ngIf="!order?.materialNotAvailable" class="card-content-block">
									<div class="card-contents-infos">
										<div class="card-content-info">
											<div class="card-content-label" translate>
												datacenter-filter.standard-steel-grade</div>
											<div class="card-product-value"
												[ngClass]="{'copo-product-highlighted':order.proposedSteelGrade?.toLowerCase()!==order.requestedSteelGrade?.toLowerCase()}">
												{{replaceNullOrUndefinedWithDashes(order.proposedSteelGrade)}}</div>
										</div>
										<div class="card-content-info">
											<div class="card-content-label" translate>
												fastlane.itemlist.product.coil_axis</div>
											<div class="card-product-value">
												{{replaceNullOrUndefinedWithDashes(order.coilAxisDescription)}}</div>
										</div>
										<div class="card-content-info">
											<div class="card-content-label" translate>order.coating</div>
											<div class="card-product-value"
												[ngClass]="{'copo-product-highlighted':order.proposedCoating?.toLowerCase()!==order.coating?.toLowerCase()}">
												{{replaceNullOrUndefinedWithDashes(order.proposedCoating)}}</div>
										</div>
										<div class="card-content-info">
											<div class="card-content-label" translate>
												fastlane.itemlist.item.additional.info</div>
											<div class="card-product-value">
												{{replaceNullOrUndefinedWithDashes(order.prototypeDescription)}}</div>
										</div>
									</div>
									<div class="card-contents-infos">
										<div class="card-content-info">
											<div class="card-content-label" translate>order-tracking.form</div>
											<div class="card-product-value">
												{{replaceNullOrUndefinedWithDashes(order.form)}}</div>
										</div>
										<div class="card-content-info">
											<div class="card-content-label" translate>
												fastlane.itemlist.coil.inner.diameter</div>
											<div class="card-product-value"
												[ngClass]="{'copo-product-highlighted':order.proposedInnerDiameter!==order.innerDiameter}">
												{{replaceNullOrUndefinedWithDashes(order.proposedInnerDiameter)}}</div>
										</div>
										<div class="card-content-info">
											<div class="card-content-label" translate>
												fastlane.itemlist.productcharacteristic.oilquantity</div>
											<div class="card-product-value"
												[ngClass]="{'copo-product-highlighted':order.proposedOiling?.toLowerCase()!==order.oiling?.toLowerCase()}">
												{{replaceNullOrUndefinedWithDashes(order.proposedOiling)}}</div>
										</div>
									</div>
									<div class="card-contents-infos">
										<div class="card-content-info">
											<div class="card-content-label" translate>
												need4steel.wizard.summary.product.dimension</div>
											<div class="card-product-value"
												[ngClass]="{'copo-product-highlighted':!compareDimentions(order.proposedDimension,getRequestDimention())}">
												{{replaceNullOrUndefinedWithDashes(order.proposedDimension)}}</div>
										</div>
										<div class="card-content-info">
											<div class="card-content-label" translate>
												need4steel-product-details.max-outside-Diameter</div>
											<div class="card-product-value"
												[ngClass]="{'copo-product-highlighted':order.proposedOutsideDiameter!==order.outsideDiameter}">
												{{replaceNullOrUndefinedWithDashes(order.proposedOutsideDiameter)}}
											</div>
										</div>
									</div>
								</div>
							</div>
						</mat-expansion-panel>
					</div>
					<div class="grid-column-one-third">
						<mat-expansion-panel [expanded]="true" class="card-info-block">
							<mat-expansion-panel-header>
								<mat-panel-title class="card-content-title">
									<span translate
										class="in-productopn-label">prototype.card.proposed.quantities</span>
									<span class="in-productopn-label">
									</span>
								</mat-panel-title>
							</mat-expansion-panel-header>
							<div class="expansion-qauanity-body">
							<mat-divider class="margin-expansion-panel"></mat-divider>
							<div>
								<div class="card-content-block" *ngIf="!order?.materialNotAvailable">
									<div class="card-contents-infos">
										<div class="card-content-info">
											<div class="card-content-label" translate>fastlane.itemlist.global.quantity
											</div>
											<div class="card-product-value"
												[ngClass]="{'copo-product-highlighted':order.proposedQuantity!==order.requestedQuantity}">
												{{replaceNullOrUndefinedWithDashes(order.proposedQuantity)}} &nbsp;<span
													*ngIf="order.proposedQuantity">{{order.proposedUnitDescription}}</span></div>
										</div>
										<div class="card-content-info">
											<div class="card-content-label" translate>
												need4steel.wizard.stepper.product.total.weight</div>
											<div class="card-product-value"
												[ngClass]="{'copo-product-highlighted':order.proposedTonnage!==order.totalTonnageCalculated}">
												{{replaceNullOrUndefinedWithDashes(order.proposedTonnage)}} &nbsp;<span
													*ngIf="order.proposedTonnage">t</span></div>
										</div>
										<div class="card-content-info" *ngIf="order.form==='Sheet'">
											<div class="card-content-label" translate>prototype.card.sheetweight</div>
											<div class="card-product-value"
												[ngClass]="{'copo-product-highlighted':order.weight!==order.sheetWeight}">
												{{replaceNullOrUndefinedWithDashes(order.weight)}}&nbsp;<span
													*ngIf="order.weight">t</span> </div>
										</div>

										<div class="card-content-info" *ngIf="order.form==='Form Blank'">
											<div class="card-content-label" translate>
												fastlane.itemlist.product.blank_weight</div>
											<div class="card-product-value"
												[ngClass]="{'copo-product-highlighted':order.proposedUnitWeight!==order.unitWeight}">
												{{replaceNullOrUndefinedWithDashes(order.proposedUnitWeight)}}<span>t</span>
											</div>
										</div>
									</div>
								</div>
							</div>
							</div>
						</mat-expansion-panel>
					</div>
					<div class="grid-column-two-third">
						<mat-expansion-panel [expanded]="true" class="card-info-block">
							<mat-expansion-panel-header>
								<mat-panel-title class="card-content-title">
									<span translate>prototype.card.proposal.deliveries</span>
								</mat-panel-title>
							</mat-expansion-panel-header>
							<mat-divider class="margin-expansion-panel"></mat-divider>
							<div>
								<div class="card-content-block" *ngIf="!order?.materialNotAvailable">
									<div class="card-contents-infos">
										<div class="card-content-info">
											<div class="card-content-label" translate>datacenter-filter.delivery-address
											</div>
											<div class=" card-product-value">
												{{replaceNullOrUndefinedWithDashes(order.shipToDescription)}}</div>
										</div>
										<div class="card-content-info">
											<div class="card-content-label card-content-proposed" translate>
												order.transport-mode</div>
											<div class="card-product-value">
												{{replaceNullOrUndefinedWithDashes(order.transportMode)}}</div>
										</div>
									</div>
									<div class="card-contents-infos">
										<div class="card-content-info">
											<div class="card-content-label" translate>
												need4steel.wizard.header.delivery.date</div>
											<div class="card-product-value">
												{{replaceNullOrUndefinedWithDashes(order.requestedDeliveryDate|copoDate:'date')}}
											</div>
										</div>
										<div class="card-content-info">
											<div class="card-content-label" translate>eoffer.incoterms</div>
											<div class="card-product-value">
												{{replaceNullOrUndefinedWithDashes(order.incoterm)}}
											</div>
										</div>
									</div>
									<div class="card-contents-infos">
										<div class="card-content-info">
											<div class="card-content-label" translate>prototype.card.deliveryweek</div>
											<div class="card-product-value">{{getRddWeek()}}</div>
										</div>
										<div class="card-content-info">
											<div class="card-content-label" translate>
												prototype.card.proposed.readyForDispatch</div>
											<div class="card-product-value">
												{{replaceNullOrUndefinedWithDashes(order.readyForDispatchWeek)}}&nbsp;<span
													*ngIf="order.readyForDispatchWeek" class="copo-data-display"
													translate>fastlane.prototype.dialog.week</span></div>
										</div>
									</div>
								</div>
							</div>
						</mat-expansion-panel>
					</div>
				</div>
				<!-- REQUEST -->
				<div class="card-title-block-non-sticky" [ngClass]="{'card-title-block-padding': order.materialNotAvailable}">
					<div class="card-title-label card-title-requested" translate>eoffer.action.new.request</div>
				</div>
				<div class="grid-6 request-block copo-container">
					<div class="grid-column-two-third">
						<mat-expansion-panel [expanded]="true" class="card-info-block">
							<mat-expansion-panel-header>
								<mat-panel-title class="card-content-title">
									<span translate>prototype.card.request.information</span>
								</mat-panel-title>
							</mat-expansion-panel-header>
							<mat-divider class="margin-expansion-panel"></mat-divider>
							<div class="card-content-block">
								<div class="card-contents-infos">
									<div class="card-content-info">
										<div class="card-content-label" translate>datacenter-filter.standard-steel-grade
										</div>
										<div class="card-content-value">
											{{replaceNullOrUndefinedWithDashes(order.requestedSteelGrade)}}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>fastlane.itemlist.product.coil_axis
										</div>
										<div class="card-product-value">
											{{replaceNullOrUndefinedWithDashes(order.coilAxisDescription)}}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>order.coating</div>
										<div class="card-content-value">
											{{replaceNullOrUndefinedWithDashes(order.coating)}}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>fastlane.itemlist.item.additional.info
										</div>
										<div class="card-content-value">
											{{replaceNullOrUndefinedWithDashes(order.prototypeDescription)}}</div>
									</div>
								</div>
								<div class="card-contents-infos">
									<div class="card-content-info">
										<div class="card-content-label" translate>order-tracking.form</div>
										<div class="card-content-value">{{replaceNullOrUndefinedWithDashes(order.form)}}
										</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>fastlane.itemlist.coil.inner.diameter
										</div>
										<div class="card-product-value">
											{{replaceNullOrUndefinedWithDashes(order.innerDiameter)}}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>
											fastlane.itemlist.productcharacteristic.oilquantity</div>
										<div class="card-content-value">
											{{replaceNullOrUndefinedWithDashes(order.oiling)}}</div>
									</div>
								</div>
								<div class="card-contents-infos">
									<div class="card-content-info">
										<div class="card-content-label" translate>
											need4steel.wizard.summary.product.dimension</div>
										<div class="card-content-value">
											{{replaceNullOrUndefinedWithDashes(getRequestDimention())}}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>
											need4steel-product-details.max-outside-Diameter</div>
										<div class="card-product-value">
											{{replaceNullOrUndefinedWithDashes(order.outsideDiameter)}}</div>
									</div>
								</div>
							</div>
						</mat-expansion-panel>
					</div>
					<div class="grid-column-one-third">
						<mat-expansion-panel [expanded]="true" class="card-info-block">
							<mat-expansion-panel-header>
								<mat-panel-title class="card-content-title">
									<span translate class="in-productopn-label">prototype.card.request.quantities</span>
									<span class="in-productopn-label">
									</span>
								</mat-panel-title>
							</mat-expansion-panel-header>
							<div class="expansion-qauanity-body">
							<mat-divider class="margin-expansion-panel"></mat-divider>
							<div class="card-content-block">
								<div class="card-contents-infos">
									<div class="card-content-info">
										<div class="card-content-label" translate>fastlane.itemlist.global.quantity
										</div>
										<div class="card-content-value">
											{{replaceNullOrUndefinedWithDashes(order.requestedQuantity)}}&nbsp;<span
												*ngIf="order.requestedQuantity">{{order.requestedQuantityUnitDescription}}</span>
										</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>
											need4steel.wizard.stepper.product.total.weight</div>
										<div class="card-content-value">
											{{replaceNullOrUndefinedWithDashes(order.totalTonnageCalculated)}}&nbsp;<span
												*ngIf="order.totalTonnageCalculated">t</span></div>
									</div>
									<div class="card-content-info" *ngIf="order.form==='Sheet'">
										<div class="card-content-label" translate>prototype.card.sheetweight</div>
										<div class="card-content-value">
											{{replaceNullOrUndefinedWithDashes(order.sheetWeight)}}&nbsp;<span>t</span>
										</div>
									</div>
									<div class="card-content-info" *ngIf="order.form==='Form Blank'">
										<div class="card-content-label" translate>fastlane.itemlist.product.blank_weight
										</div>
										<div class="card-content-value">
											{{replaceNullOrUndefinedWithDashes(order.unitWeight)}}&nbsp;<span>t</span>
										</div>
									</div>
								</div>
							</div>
							</div>
						</mat-expansion-panel>
					</div>
					<div class="grid-column-two-third">
						<mat-expansion-panel [expanded]="true" class="card-info-block">
							<mat-expansion-panel-header>
								<mat-panel-title class="card-content-title">
									<span translate>prototype.card.request.deliveries</span>
								</mat-panel-title>
							</mat-expansion-panel-header>
							<mat-divider class="margin-expansion-panel"></mat-divider>
							<div class="card-content-block">
								<div class="card-contents-infos">
									<div class="card-content-info">
										<div class="card-content-label" translate>datacenter-filter.delivery-address
										</div>
										<div class="card-content-value">
											{{replaceNullOrUndefinedWithDashes(order.shipToDescription)}}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>order.transport-mode</div>
										<div class="card-content-value">
											{{replaceNullOrUndefinedWithDashes(order.transportMode)}}</div>
									</div>
								</div>
								<div class="card-contents-infos">
									<div class="card-content-info">
										<div class="card-content-label" translate>need4steel.wizard.header.delivery.date
										</div>
										<div class="card-content-value">
											{{replaceNullOrUndefinedWithDashes(order.requestedDeliveryDate|copoDate:'date')}}
										</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>eoffer.incoterms</div>
										<div class="card-content-value">
											{{replaceNullOrUndefinedWithDashes(order.incoterm)}}</div>
									</div>
								</div>
								<div class="card-contents-infos">
									<div class="card-content-info">
										<div class="card-content-label" translate>prototype.card.deliveryweek</div>
										<div class="card-content-value">
											{{replaceNullOrUndefinedWithDashes(getRddWeek())}}</div>
									</div>
								</div>
							</div>
						</mat-expansion-panel>
					</div>
				</div>
			</ng-container>
		</ng-container>
	</ng-container>
	<ng-template #offline>
		<copo-offline></copo-offline>
	</ng-template>
	<ng-template #loading>
		<copo-loading-spinner></copo-loading-spinner>
	</ng-template>
</div>